import { Box, CssReset, NavBar, PageHeader, SolvTheme, Stack } from '@solvhealth/jigsaw-v1';
import React, { useEffect } from 'react';
import Triage from '~/components/AccountGetsMarried/components/GetCare/components/NavTiles/components/Triage/Triage';
import { ServicesSearch } from '~/components/AccountGetsMarried/components/GetCare/components/Services';
import { useConsumerServiceCategories } from '~/components/AccountGetsMarried/constants/hooks/useConsumerServiceCategories';
import ServiceCategoryCard from '~/components/Services/ServiceCategoryCard';
import { analyticsTrackEvent } from '~/core/analytics';
import {
  CONSUMER_SERVICES_ENTRYPOINT_CATEGORY_LIST_PAGE,
  TRIAGE_ENTRYPOINT_VISIBLE,
} from '~/core/analytics/events';
import { useTriageEnabled } from '~/hooks/useTriageEnabled';

const PAGE_NAME_FOR_ANALYTICS = 'Service categories list page';
export type ServiceCategoriesListPageNameForAnalytics = typeof PAGE_NAME_FOR_ANALYTICS;

function ServiceCategoriesListPage() {
  const triageEnabled = useTriageEnabled();

  useEffect(() => {
    analyticsTrackEvent(TRIAGE_ENTRYPOINT_VISIBLE, {
      entrypoint: PAGE_NAME_FOR_ANALYTICS,
      visible: triageEnabled,
    });
  }, [triageEnabled]);

  const categories = useConsumerServiceCategories(CONSUMER_SERVICES_ENTRYPOINT_CATEGORY_LIST_PAGE);

  return (
    <Stack space={4}>
      <NavBar>Browse all services</NavBar>
      <Stack maxWidth={SolvTheme.breakpoints.sm} mx="auto" pb={3} space={4} width="100%">
        <Box px={3}>
          <ServicesSearch entrypoint="service categories list page" />
        </Box>

        <Box px={3}>
          <PageHeader
            subtitle="Did you know that you can book 150+ primary and urgent care services through Solv? From routine exams to acute care, we've got your back."
            title="Services and Treatments"
          />
        </Box>
        <Box
          display="grid"
          gridGap={SolvTheme.space[2]}
          mx={3}
          sx={{ gridTemplateColumns: '1fr 1fr', gridAutoRows: '1fr' }}
        >
          {categories.map((category) => (
            <ServiceCategoryCard
              category={category}
              entrypoint="category list page"
              key={category.slug}
            />
          ))}
        </Box>
        {triageEnabled && (
          <Box px={{ _: 0, sm: 3 }}>
            <Triage entrypoint={PAGE_NAME_FOR_ANALYTICS} />
          </Box>
        )}
      </Stack>
      <CssReset />
    </Stack>
  );
}

export default ServiceCategoriesListPage;
